module.exports = __webpack_public_path__ + "img/app-store.eb1f4ef8.png";